import { Infer, t } from 'typegate';
import { uuid } from '../utilities/typegateCustomValidators';

/**
 * Underwriting requirements are data that a carrier or a third-party can send us after processing a submitted application or other
 * This data is related to an application and is stored on the platform side mainly for display purposes.
 *
 * The types below describe the structure of the underwriting requirements data that we expect to receive from external providers on the one hand,
 * and the structure of the data that we are storing in the database on the other hand.
 *
 * TODO: We will need to support provider-specific requirements in the future, so the schema will need to be updated accordingly to accommodate
 * provider-specific fields or structures (leveraging carrier implementations or building a schema repository in this shared package).
 * https://zinnia.atlassian.net/browse/HOT-5448
 */

const requirementsSchema = t.array(
  t.object(
    t.optionalProperty('id', t.string),
    t.property('text', t.object(t.property('en', t.string), t.property('fr', t.string))),
    t.optionalProperty('decision', t.string),
    t.optionalProperty('decisionText', t.object(t.property('en', t.string), t.property('fr', t.string))),
  ),
);

export const underwritingRequirementsSchema = t
  .object(
    t.property('applicationId', uuid),
    t.property('participantId', uuid),
    t.optionalProperty('provider', t.string),
    t.property('requirements', requirementsSchema),
  )
  .setTypeName('UnderwritingRequirements');

export type UnderwritingRequirements = Infer<typeof underwritingRequirementsSchema>;
export const createUnderwritingRequirementsDataSchema = t.array(underwritingRequirementsSchema);

export const underwritingRequirementPayloadSchema = t
  .object(
    t.property('policyNumber', t.string),
    t.property(
      'participants',
      t.array(t.object(t.property('participantId', uuid), t.property('requirements', requirementsSchema))),
    ),
  )
  .setTypeName('UnderwritingRequirementPayload');

export type UnderwritingRequirementPayload = Infer<typeof underwritingRequirementPayloadSchema>;
